var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2476_13611)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FDFDFD",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 36V34.1625C16 33.3264 16.3972 32.6458 17.1917 32.1208C17.9861 31.5958 19.0333 31.3333 20.3333 31.3333C20.5681 31.3333 20.7938 31.3382 21.0104 31.3479C21.2271 31.3576 21.4347 31.3819 21.6333 31.4208C21.3806 31.8292 21.191 32.2569 21.0646 32.7042C20.9382 33.1514 20.875 33.6181 20.875 34.1042V36H16ZM22.5 36V34.1042C22.5 33.4819 22.658 32.9132 22.974 32.3979C23.2899 31.8826 23.7368 31.4306 24.3146 31.0417C24.8924 30.6528 25.583 30.3611 26.3865 30.1667C27.1899 29.9722 28.0611 29.875 29 29.875C29.9569 29.875 30.8372 29.9722 31.6406 30.1667C32.4441 30.3611 33.1347 30.6528 33.7125 31.0417C34.2903 31.4306 34.7326 31.8826 35.0396 32.3979C35.3465 32.9132 35.5 33.4819 35.5 34.1042V36H22.5ZM37.125 36V34.1042C37.125 33.5986 37.0663 33.1222 36.949 32.675C36.8316 32.2278 36.6556 31.8097 36.4208 31.4208C36.6194 31.3819 36.8226 31.3576 37.0302 31.3479C37.2378 31.3382 37.45 31.3333 37.6667 31.3333C38.9667 31.3333 40.0139 31.591 40.8083 32.1062C41.6028 32.6215 42 33.3069 42 34.1625V36H37.125ZM20.3333 30.1667C19.7375 30.1667 19.2274 29.9382 18.8031 29.4812C18.3788 29.0243 18.1667 28.475 18.1667 27.8333C18.1667 27.1722 18.3788 26.6181 18.8031 26.1708C19.2274 25.7236 19.7375 25.5 20.3333 25.5C20.9472 25.5 21.4618 25.7236 21.8771 26.1708C22.2924 26.6181 22.5 27.1722 22.5 27.8333C22.5 28.475 22.2924 29.0243 21.8771 29.4812C21.4618 29.9382 20.9472 30.1667 20.3333 30.1667ZM37.6667 30.1667C37.0708 30.1667 36.5608 29.9382 36.1365 29.4812C35.7122 29.0243 35.5 28.475 35.5 27.8333C35.5 27.1722 35.7122 26.6181 36.1365 26.1708C36.5608 25.7236 37.0708 25.5 37.6667 25.5C38.2806 25.5 38.7951 25.7236 39.2104 26.1708C39.6257 26.6181 39.8333 27.1722 39.8333 27.8333C39.8333 28.475 39.6257 29.0243 39.2104 29.4812C38.7951 29.9382 38.2806 30.1667 37.6667 30.1667ZM29 29C28.0972 29 27.3299 28.6597 26.6979 27.9792C26.066 27.2986 25.75 26.4722 25.75 25.5C25.75 24.5083 26.066 23.6771 26.6979 23.0063C27.3299 22.3354 28.0972 22 29 22C29.9208 22 30.6927 22.3354 31.3156 23.0063C31.9385 23.6771 32.25 24.5083 32.25 25.5C32.25 26.4722 31.9385 27.2986 31.3156 27.9792C30.6927 28.6597 29.9208 29 29 29Z",
    fill: "#004B49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2476_13611",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.52549 0 0 0 0 0.356863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2476_13611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2476_13611",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.4979ce1ce9a5234bf997122bd42cbc1e.svg";
export { ForwardRef as ReactComponent };